class RewardsPopup extends ModalDialog {
  constructor() {
    super();
    this.wrapper = this.querySelector(".rewards-popup__wrapper");
    this.buttonClose = this.querySelector('[id^="ModalClose-"]');
    this.rewardsBlocks = this.querySelectorAll(".rewards-popup__rewards-block");
    this.rewardsBlocksGiftWrappers = this.querySelectorAll(".rewards-popup__products");
    this.allGiftsIds = Array.from(
      this.querySelectorAll(".rewards-popup__product-link input")
    ).map((input) => input.value);
    this.cta = this.querySelector(".rewards-popup__cta button");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.excludedProducts = window.excludedProducts || [];
  }

  attachEventListeners() {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      this.updateCart(data.cart);
    });

    document.addEventListener('click', (event) => {
      if (event.target === this) {
        this.hide();
      }
    });
  }

  async updateCart(cart) {
    if (!cart || !cart.total_price) {
      cart = await fetch("/cart.js").then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to fetch cart data");
        }
      });
    }

    // Calculate excluded products' price to subtract from total
    const excludedProductsPrice = cart.items.reduce((sum, item) => {
      if (this.excludedProducts.includes(item.product_id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    const totalSpent = (cart.total_price - excludedProductsPrice) / 100;

    this.rewardsBlocks.forEach((block) => {
      const threshold = parseFloat(block.dataset.rewardsThreshold);
      if (totalSpent >= threshold) {
        block.classList.add("active");
      } else {
        block.classList.remove("active");
        const checkedInput = block.querySelector('input:checked');
        if (checkedInput) {
          checkedInput.checked = false;
        }
      }

      const productInputs = block.querySelectorAll(".rewards-popup__product-link input");
      productInputs.forEach((input) => {
        const productId = input.value;
        const isChecked = input.checked;
        const isInCart = cart.items.some((item) => item.variant_id.toString() === productId);

        if (isChecked && !isInCart) {
          input.checked = false;
        }
      });
    });

    this.validateRewards(cart);
    if (this.showPopup(cart)) {
      this.show();
    }
  }

  async validateRewards(cart) {
    if (!cart || !cart.total_price) {
      cart = await fetch("/cart.js").then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to fetch cart data");
        }
      });
    }

    // Calculate excluded products' price to subtract from total
    const excludedProductsPrice = cart.items.reduce((sum, item) => {
      if (this.excludedProducts.includes(item.product_id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    const totalSpent = (cart.total_price - excludedProductsPrice) / 100;

    const productsInCart = cart.items.filter((item) =>
      this.allGiftsIds.includes(item.id.toString())
    );

    if (productsInCart.length === 0) {
      return true;
    }

    const updates = {};
    productsInCart.forEach((item) => {
      const productId = item.id.toString();
      const lineItemKey = item.key;
      const rewardThreshold = this.querySelector(`input[value="${productId}"]`)
        ?.dataset.rewardThreshold;

      const thresholdMet = totalSpent >= parseFloat(rewardThreshold);
      if (!thresholdMet) {
        updates[lineItemKey] = 0;
        this.querySelector(`.rewards-popup__product-link input[value="${productId}"]`).checked = false;
      } else if (item.quantity > 1) {
        updates[lineItemKey] = 1;
      }
    });

    const duplicateRewards = this.checkForDuplicateRewards(
      productsInCart,
      cart
    );

    duplicateRewards.forEach((key) => {
      updates[key] = 0;
    });

    if (Object.keys(updates).length > 0) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((data) => {
              this.cart?.renderContents(data);
            });
          } else {
            response.json().then((error) => {
              console.error("Error updating cart:", error);
            });
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
      return false;
    }
    return false;
  }

  checkForDuplicateRewards(productsInCart) {
    const duplicateProductKeys = [];
    const activeBlocks = Array.from(
      this.querySelectorAll(".rewards-popup__rewards-block.active")
    );

    const activeBlockProducts = activeBlocks.map((block) => {
      const productInputs = block.querySelectorAll(
        ".rewards-popup__product-link input"
      );
      return Array.from(productInputs).map((input) => input.value);
    });

    activeBlockProducts.forEach((blockProducts) => {
      const selectedProducts = productsInCart.filter((item) =>
        blockProducts.includes(item.id.toString())
      );
      if (selectedProducts.length > 1) {
        var productKeys = selectedProducts.map((item) => item.key);
      }
      if (productKeys?.length > 1 && productKeys !== undefined) {
        duplicateProductKeys.push(...productKeys.slice(1));
      }
    });
    return duplicateProductKeys;
  }

  showPopup(cart) {
    if (!cart || !cart.total_price) {
      return false;
    }

    const productsInCart = cart.items.filter((item) =>
      this.allGiftsIds.includes(item.id.toString())
    );

    // Calculate excluded products' price to subtract from total
    const excludedProductsPrice = cart.items.reduce((sum, item) => {
      if (this.excludedProducts.includes(item.product_id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    const totalSpent = (cart.total_price - excludedProductsPrice) / 100;
    let showPopup = false;

    this.rewardsBlocks.forEach((block) => {
      const threshold = parseFloat(block.dataset.rewardsThreshold);
      const blockProductIds = Array.from(
        block.querySelectorAll(".rewards-popup__product-link input")
      ).map((input) => input.value);

      const productsInBlock = productsInCart.filter((item) =>
        blockProductIds.includes(item.id.toString())
      );

      if (totalSpent >= threshold && productsInBlock.length == 0) {
        showPopup = true;
      }
    });

    return showPopup;
  }

  async handleRewardSelection(event) {
    event?.preventDefault();
    this.cta?.querySelector('.loading__spinner').classList.remove('hidden');
    this.cta?.querySelector('span').classList.add('hidden');
    const activeBlocks = Array.from(
      this.querySelectorAll(".rewards-popup__rewards-block.active")
    );

    const selectedProducts = this.querySelectorAll(
      ".rewards-popup__product-link input:checked"
    );

    if (selectedProducts.length == activeBlocks.length) {
      const cart = await fetch("/cart.js");
      if (!cart.ok) {
        console.error("Failed to fetch cart data");
      }

      const cartData = await cart.json();
      const productsInCart = cartData.items.filter((item) =>
        this.allGiftsIds.includes(item.id.toString())
      ).map((item) => item.id.toString());

      const prodctsToAdd = Array.from(selectedProducts).filter((input) => {
        const productId = input.value;
        return !productsInCart.includes(productId);
      });

      let formData = {
        items: [
          ...Array.from(prodctsToAdd).map((input) => {
            const productId = input.value;
            const rewardThreshold = input.dataset.rewardThreshold;
            return {
              id: productId,
              quantity: 1,
              properties: {
                "_Reward Threshold": `${window.theme.settings.symbol || '$'}${rewardThreshold}`,
              },
            };
          }),
        ],
        sections: this.cart
          ?.getSectionsToRender()
          .map((section) => section.section),
        sections_url: window.location.pathname,
      };

      this.querySelector('.rewards-popup__inner').style.opacity = '0.5';
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((data) => {
              console.log("Product added to cart:", data);
              this.validateRewards();
              this.cart?.renderContents(data);
              this.hide(false);
            });
          } else {
            response.json().then((error) => {
              console.error("Error adding product to cart:", error);
            });
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        })
        .finally(() => {
          this.cta?.querySelector('.loading__spinner').classList.add('hidden');
          this.cta?.querySelector('span').classList.remove('hidden');
          this.querySelector('.rewards-popup__inner').style.opacity = '';
          return true;
        });
    } else {
      this.cta?.querySelector('.loading__spinner').classList.add('hidden');
      this.cta?.querySelector('span').classList.remove('hidden');
      alert("Please select a product for each tier.");
      return false;
    }
  }

  celebrate() {
    var end = Date.now() + 2 * 1000;

    var colors = ["#ff8da1", "#ffffff", "##E09691"];
    let zIndex = 2147483647;

    (function frame() {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 70,
        origin: { x: 0 },
        colors: colors,
        zIndex: zIndex,
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 70,
        origin: { x: 1 },
        colors: colors,
        zIndex: zIndex,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  show(opener) {
    super.show(opener);
    this.celebrate();
    setTimeout(() => {
      this.wrapper.classList.add("open");
    }, 10);
    document.documentElement.style.overflow = "hidden";
    this.rewardsBlocks.forEach((block) => {
      if (block.classList.contains("active") && !block.querySelector('.rewards-popup__product-link input:checked') && !block.classList.contains('is-active')) {
        block.classList.add('is-pending-selection');
      }
    });


    const firstOpenBlock = this.querySelector(".rewards-popup__rewards-block.is-pending-selection");
    if (firstOpenBlock) {
      firstOpenBlock.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }

  async hide(close = true) {
    if(close){
      const hidePopup = await this.handleRewardSelection();
      if (!hidePopup) return;
    }
    this.wrapper.classList.remove("open");
    await new Promise(resolve => setTimeout(resolve, 300));
    super.hide();
    document.documentElement.style.overflow = "";
  }

  connectedCallback() {
    this.attachEventListeners();
    this.cta?.addEventListener("click", (event) =>
      this.handleRewardSelection(event)
    );

    this.rewardsBlocks.forEach((wrapper) => {
      wrapper.addEventListener('change', (event) => {
        wrapper.classList.remove('is-pending-selection');

        if(this.querySelector(".rewards-popup__rewards-block.is-pending-selection")){
          this.querySelector(".rewards-popup__rewards-block.is-pending-selection").scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        } else if(!this.querySelector(".rewards-popup__rewards-block.is-pending-selection")){
          this.handleRewardSelection();
        }
      });
    });

  }
}
customElements.define("rewards-popup", RewardsPopup);